module.exports = __webpack_public_path__ + "static/media/13.fbf3793a.jpeg";